import { enhancedApi } from '@store/generated/eval-results';

const EVAL_RESULTS_TAG_TYPES = ['EvalResult', 'EvalResultList'] as const;

export const evalResultsApi = enhancedApi.enhanceEndpoints({
  addTagTypes: EVAL_RESULTS_TAG_TYPES,
  endpoints: {
    getV2AdminCortexEvalResults: {
      providesTags: result =>
        result
          ? [
              ...result.items.map(row => ({
                type: 'EvalResult' as const,
                id: row.eval_result_id,
              })),
              { type: 'EvalResultList' as const, id: 'LIST' },
            ]
          : [{ type: 'EvalResultList' as const, id: 'LIST' }],
    },
    getV2AdminCortexEvalResultsByResultId: {
      providesTags: (_result, _error, { resultId }) => [
        { type: 'EvalResult' as const, id: resultId },
      ],
    },
    patchV2AdminCortexEvalResultsByResultIdReview: {
      invalidatesTags: (_result, _error, { resultId }) => [
        { type: 'EvalResult' as const, id: resultId },
        { type: 'EvalResultList' as const, id: 'LIST' },
      ],
    },
  },
});

export type { EvalResultResponse, HumanVerdict } from '@store/generated/eval-results';
